import { Component, computed, inject } from '@angular/core';
import {
  DynamicFormField,
  formBuilder,
  selectLazy,
} from '@kinet-open-network/client/core/forms/ui';
import { TagsService } from '@kinet-open-network/client/tags/data-access';
import { FormlyModule } from '@ngx-formly/core';
import {
  ACTION_DATA_TEMPLATE,
  ActionComponent,
} from './abstract-action.component';

@Component({
  selector: 'kon-remove-tag-action',
  imports: [FormlyModule],
  template: ACTION_DATA_TEMPLATE,
})
export class RemoveTagActionComponent extends ActionComponent<'remove_tag'> {
  readonly #tagService = inject(TagsService);

  override fields = computed<DynamicFormField[]>(() =>
    formBuilder([
      selectLazy('tagId', 'Tag', 'label', 'id')
        .query(this.#tagService)
        .required(true),
    ]),
  );
}
